import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const CardTitle = styled.div`
  font-size: 18px;
  line-height: 24px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  font-weight: 600;
`;

const StyledContainer = styled.div`
  padding: 18px;
  border-radius: 8px;
  border: solid 1px ${withVar(DesignToken.BorderBasicSecondary)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  margin-top: 10px;
`;

const ImageWrapper = css`
  background-color: ${withVar(DesignToken.SurfaceTertiaryDefault)};
  display: inline-block;
  margin-right: 10px;
  border-radius: 4px;
  width: 24px;
  height: 24px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

interface IProps {
  title: string;
  children?: React.ReactNode;
  imgUrl?: string;
}

export class Card extends React.PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return (
      <StyledContainer>
        <Row>
          {this.props.imgUrl && <img src={this.props.imgUrl} css={ImageWrapper} />}
          <CardTitle>{this.props.title}</CardTitle>
        </Row>
        {this.props.children}
      </StyledContainer>
    );
  }
}
